import React, {useEffect} from 'react';
import {inject, observer} from 'mobx-react';
import {useParams} from 'react-router-dom';
import AiAssistantChatbotStore from '../../../../modules/AiAssistantChatbot/store/AiAssistantChatbotStore';
import AiAssistantStore from '../store/AiAssistnatStore';
import {AiAssistantChatbot} from '../../../../modules/AiAssistantChatbot';

interface Props {
  aiAssistantChatbotStore?: AiAssistantChatbotStore;
  aiAssistantStore?: AiAssistantStore;
}

const AiAssistantChatPageContainer = inject('aiAssistantChatbotStore')(
  observer(({aiAssistantChatbotStore}: Props) => {
    const {assistantId} = useParams();

    useEffect(() => {
      if (assistantId) {
        aiAssistantChatbotStore!.showChatbot(assistantId ?? '');
      }
    }, []);

    return <AiAssistantChatbot uiType="page" />;
  }),
);

export default AiAssistantChatPageContainer;
